import React, {Component} from 'react';
import {withRouter} from "react-router";
import {translate} from 'react-i18next';
import MyLink from "../../modules/MyLink";

class About extends Component {
    render() {
        const {t, i18n} = this.props;
        return (
            <div className={'center'}>
                <div className={'max-width about-container'}>
                    <div className={'left'}>
                        <h2>{t('about.title')}</h2>
                        <div className={'h-text'} style={{marginBottom: 0}}>
                            {t('about.text')}
                        </div>
                        <MyLink to={'/'+i18n.language + '/about'} text={t('learn-more')}/>
                    </div>
                    <div className={'right'}>

                        <div className={'flex-about'}>
                            <div className={'item'}>
                                <h3 className={'title'}>{t('about.block1.title')}</h3>
                                <div className={'text'}>
                                    {t('about.block1.text')}
                                </div>
                            </div>
                            <div className={'item'}>
                                <h3 className={'title'}>{t('about.block2.title')}</h3>
                                <div className={'text'}>
                                    {t('about.block2.text')}
                                </div>
                            </div>
                        </div>

                        <div className={'flex-about'}>
                            <div className={'item'}>
                                <h3 className={'title'}>{t('about.block3.title')}</h3>
                                <div className={'text'}>
                                    {t('about.block3.text')}
                                </div>
                            </div>
                            <div className={'item'}>
                                <h3 className={'title'}>{t('about.block4.title')}</h3>
                                <div className={'text'}>
                                    {t('about.block4.text')}
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        )
    }
}

export default withRouter(translate('home')(About));
